<template>
	<div>
		<div v-if="Object.keys(files).length > 0" class="field file-padded-bottom-border file-table-header">
			<div class="control">
				<div class="columns">
					<div class="column is-4">
						<div class="formfield file-header">File</div>
					</div>
					<div class="column is-4">
						<div class="formfield file-header file-header-date">
							Expiration Date
						</div>
					</div>
					<div class="column is-4">
						<div class="formfield file-header file-header-date">
							Date Uploaded
						</div>
					</div>
				</div>
			</div>
		</div>

		<div v-for="(file, index) in files" :key="file.id" class="field file-padded-top file-table-row">
			<div class="control">
				<div class="columns">
					<div class="column is-4 compliance-file-name">
						<span
							class="formfield view-file"
							@click="showVendorComplianceDetail(file)"
							v-html="truncateFilename(file.filename)"
						></span>
						<i v-if="file.reviewed_by === null || file.reviewed_by === ''"
							@click.prevent="setDelete(file.id)"
							class="fa fa-trash-alt file-delete"
							aria-hidden="true"
						></i>
					</div>
					<div class="column is-4">
						<div class="formfield">
							<div class="uploaded-at pull-left file-expiration">
								{{ formatDateTime(file.expiration_date) }}
							</div>
						</div>
					</div>
					<div class="column is-4">
						<div class="formfield">
							<div class="uploaded-at pull-left file-uploaded">
								{{ formatDateTime(file.created_at) }}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapState } from "vuex";
import moment from "moment";
import { truncateFilename } from "@/utils/filename";

export default {
	computed: {
		...mapState("vendorComplianceDetails", {
			files: (state) => state.currentVendorComplianceDetails,
		}),
	},
	methods: {
		truncateFilename,
		// format datetime to 12/01/18 at 4:00 PM
		formatDateTime(value) {
			if (!value) return "Unknown";
			return (
				moment(value).format("MM/DD/YY") +
				" at " +
				moment(value).format("hh:mm A")
			);
		},
		showVendorComplianceDetail(file) {
				VueStore.dispatch("vendorComplianceDetails/getFileURL", file.id);
				VueStore.dispatch("notify/setVariable", {
						key: "viewVendorComplianceDetailsModal",
						value: true,
				});
		},
		setDelete(id) {
			// show modal to confirm deletion
			VueStore.dispatch("notify/setVariable", {
				key: "showDeleteVendorComplianceDetailConfirm",
				value: true,
			});

			// setup vuex to so we can pull the selected id to delete
			// after user confirm
			VueStore.dispatch("vendorComplianceDetails/pushToFileDelete", id);
		},

	},
};
</script>
<style>
.expired{
	color: red;
}

.expiring-soon{
	color: orange;
}

/* Desktop: pin each row's delete icon to the row itself so every icon
   lines up vertically across rows, regardless of where the date text
   wraps in a given row. */
.file-table-row{
	position: relative;
}
.file-table-row .file-delete{
	position: absolute;
	top: 13px;
	right: 0;
}

/* Bulma's .columns carries negative top/bottom margins (-0.75rem); the
   :last-child one ties our override on specificity, so !important is
   needed to zero them. Without this, each row's height ends short of its
   content and the separator cuts through the details text. */
.file-table-row .columns{
	margin: 0 !important;
}

/* Mobile: the three is-4 columns stack into their own full-width lines,
   which reads as a jumble of labels. Instead, hide the header row and show
   each date with its label inline, under the file name. */
@media screen and (max-width: 768px){
	.file-table-header{
		display: none;
	}
	.file-table-row .columns{
		display: block;
	}
	/* Full-width columns with breathing room between the stacked lines
	   and between consecutive files. */
	.file-table-row .column{
		padding: 0 0 6px;
		width: 100%;
	}
	/* Separate consecutive files with extra spacing. (The app sets
	   .field margin-bottom to 0 with !important, so spacing has to come
	   from margin-top here.) */
	.file-table-row + .file-table-row{
		margin-top: 16px;
	}
	.file-expiration::before{
		content: "Expiration: ";
		color: #777777;
		font-weight: bold;
	}
	.file-uploaded::before{
		content: "Uploaded: ";
		color: #777777;
		font-weight: bold;
	}
	.file-uploaded{
		margin-top: 2px;
	}
	/* Keep the delete icon on the file name's own line, right-aligned:
	   in normal flow (floated) so it always lines up with that row's
	   file name, regardless of row height. */
	.file-table-row .file-delete{
		position: static;
		float: right;
		margin-right: 10px;
	}
	.file-table-row .uploaded-at{
		padding-right: 0;
	}

	.compliance-file-name{
		margin-top: 20px !important;
	}
}
</style>